import {
  Box,
  Checkbox,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Textarea,
} from "@mui/joy";
import type { Answer, AssessmentQuestion } from "./assessmentApi";

export function AssessmentQuestionField({
  question: q,
  value,
  onChange,
  disabled = false,
}: {
  question: AssessmentQuestion;
  value?: Answer;
  onChange: (value: Answer) => void;
  disabled?: boolean;
}) {
  return (
    <FormControl required={q.required} disabled={disabled}>
      <FormLabel
        id={`label-${q.id}`}
        sx={{ fontSize: "1.05rem", alignItems: "flex-start" }}
      >
        {q.prompt}
      </FormLabel>
      {q.help && <FormHelperText sx={{ mb: 1 }}>{q.help}</FormHelperText>}
      {q.type === "choice" ? (
        <RadioGroup
          aria-labelledby={`label-${q.id}`}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          sx={{ gap: 1, mt: 1 }}
        >
          {q.options.map((o) => (
            <Radio
              key={o.id}
              value={o.id}
              label={o.label}
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: "md",
                p: 1.5,
                minHeight: 48,
              }}
            />
          ))}
        </RadioGroup>
      ) : q.type === "multi" ? (
        <Box sx={{ display: "grid", gap: 1.5, py: 1 }}>
          {q.options.map((o) => (
            <Checkbox
              key={o.id}
              label={o.label}
              checked={Array.isArray(value) && value.includes(o.id)}
              onChange={(e) =>
                onChange(
                  e.target.checked
                    ? [...(Array.isArray(value) ? value : []), o.id]
                    : (Array.isArray(value) ? value : []).filter(
                        (v) => v !== o.id,
                      ),
                )
              }
            />
          ))}
        </Box>
      ) : q.type === "number" ? (
        <Input
          aria-labelledby={`label-${q.id}`}
          type="number"
          value={(value as string) ?? ""}
          onChange={(e) => onChange(e.target.value)}
          slotProps={{ input: { step: "any" } }}
        />
      ) : (
        <Textarea
          aria-labelledby={`label-${q.id}`}
          minRows={4}
          value={(value as string) ?? ""}
          onChange={(e) => onChange(e.target.value)}
          slotProps={{ textarea: { maxLength: 10000 } }}
        />
      )}
    </FormControl>
  );
}
